<template>
    <div class="confidentiality-setting">
        <div class="item" v-for="(item, index) in mycarList" :key="index">
            <div class="plate-num">
                {{ parseCarCode(item.plateNum) }}
            </div>
            <div class="bottom">
                <div class="right" @click="confidentialityFreePayment(item)">
                    微信免密支付
                    <van-icon name="arrow" />
                </div>

            </div>
        </div>
        <div></div>
    </div>
</template>

<script>
import { parseCarCode, obj2Param } from '@/libs/tools'
import { listMyPlateNum } from '@/api/api'
import { mapGetters } from 'vuex'
import { jumpWxMiniProgram } from '@/libs/tools'

export default {
    name: 'ConfidentialitySetting',

    data() {
        return {

            mycarList: [],
        }
    },

    mounted() {
        this.getListMyPlateNum()
    },
    computed: {
        ...mapGetters({ appEnv: 'getAppEnv' })
    },
    methods: {
        parseCarCode,
        // 获取绑定车牌
        getListMyPlateNum() {
            listMyPlateNum().then((res) => {
                this.mycarList = res.data
            })
        },

        // 修改钱包无感支付状态
        switchWalletNofeelPay(value, item) {


            let { plateColor, plateNum } = item
            updateWalletNofeelPay({
                plateColor, plateNum, status: value
            }).then(res => {
                this.$toast('设置成功!')
                this.getListMyPlateNum()
            }).catch(error => {
                item.walletNofeelPay = !item.walletNofeelPay
            })
        },

        confidentialityFreePayment(item) {
            let { plateNum } = item
            let plateColor = ''
            if (plateNum.length == 7) plateColor = 0
            else if (plateNum.length == 8) plateColor = 4
            let obj = { plateColor, plateNum, userId: localStorage.getItem('userId') }
            if (this.appEnv.appEnv == 'miniprogram') {
                wx.miniProgram.navigateTo({
                    url: `/pages/tab2/freePayment/freePayment?${obj2Param(obj)}`,
                });
            }
            else {
                this.$toast('本功能只支持在微信小程序中使用')
            }

        }
    }
}
</script>

<style lang="less" scoped>
.confidentiality-setting {
}

.item {
    margin: 27px auto 0 auto;
    width: 670px;
    height: 215px;
    background: url("~@/assets/images/parking/mycar/setting.png") no-repeat;
    background-size: 100% 100%;

    .plate-num {
        height: 145px;
        font-size: 54px;
        line-height: 145px;
        font-family: "PingFangSC-Medium";
        color: #fff;
        padding-left: 83px;
    }

    .bottom {
        height: 70px;
        display: flex;
        align-items: center;
        flex-direction: row-reverse;
        color: rgba(11, 102, 204, 1);
        font-size: 24px;

        .left,
        .right {
            width: 50%;
            text-align: center;
        }

        .line {
            height: 39px;
            width: 1px;
            background-color: rgba(169, 208, 239, 1);
        }

        .left {
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .right {
        }
    }
}
</style>
